(function() {
    'use strict';

    angular.module('user')
        .controller('DiscountGroupCreateController', DiscountGroupCreateController);

    DiscountGroupCreateController.$inject = ['$state', 'discountGroupDataSrvc', 'notificationSrvc', 'discountGroupMessagesConst', 'errorNotificationSrvc'];

    function DiscountGroupCreateController($state, discountGroupDataSrvc, notificationSrvc, discountGroupMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            name_de: [],
            name_en: [],
            name_cpde: [],
            name_cpen: [],
            net_turnover: [],
            orders_count: [],
            days_count: [],
            value: [],
            nonFieldErrors: []
        };
        self.discountGroupData = {
            name_pl: '',
            name_de: '',
            name_en: '',
            name_cpde: '',
            name_cpen: '',
            net_turnover: null,
            orders_count: null,
            days_count: null,
            value: null
        };

        self.createDiscountGroup = createDiscountGroup;
        self.cleanErrors = cleanErrors;

        function createDiscountGroup() {
            discountGroupDataSrvc.create(
                self.discountGroupData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", discountGroupMessagesConst.add);
                    $state.go('layout.discountGroup.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }
    }
})();
